import { Formik } from 'formik';

import { Messages } from 'config';
import { handleMutation } from 'hooks';
import { ButtonStyleTypes } from 'types';
import { useEditMutation, EventFormValues } from 'store/api/event';
import {
  Dialog,
  Button,
  DialogType,
  ButtonTypes,
  CommonStyles,
  EventTeamAssignSelects,
} from 'components';

import { AssignTeamDialogProps } from './types';

export const AssignTeamDialog = ({
  event,
  ...props
}: AssignTeamDialogProps) => {
  const [edit, mutation] = useEditMutation();

  handleMutation({
    ...mutation,
    successMessage: `Event ${Messages.UPDATED_SUCCESSFULLY}`,
  });

  return (
    <Dialog {...props} title="Assign team">
      {(close, _, ButtonsComponent) => (
        <Formik<{ id: string } & Partial<EventFormValues>>
          initialValues={{
            id: String(event?.id),
            leaderId: event?.leaderId,
            companyId: event?.companyId,
            teamMembers: event?.teamMembers?.map(
              (teamMember) => teamMember?.id
            ),
          }}
          onSubmit={async (values) => {
            try {
              const response = await edit(values).unwrap();
              if (response.id) {
                close();
              }
            } catch {
              // handled error in mutation
            }
          }}
        >
          {({ dirty, isSubmitting }) => (
            <CommonStyles.Form>
              <EventTeamAssignSelects />

              <ButtonsComponent type={DialogType.Plain}>
                <Button
                  text="Cancel"
                  onClick={close}
                  styleType={ButtonStyleTypes.Outline}
                />

                <Button
                  text="Confirm"
                  type={ButtonTypes.Submit}
                  disabled={!dirty || isSubmitting}
                />
              </ButtonsComponent>
            </CommonStyles.Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};
